//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import util from '@/libs/util.js';
import VueUeditorWrap from 'vue-ueditor-wrap';
// import '../../../static/wwei_editor.css';
import '../../../src/styles/wwei_editor.css';
import fileUploader from '../../views/common-components/file-uploader.vue';
import EditorTemplates from '../common-components/editor-templates';
import selectNodeModal from '../common-components/select-node-modal.vue';

export default {
    name: 'contentEdit',
    components: {
        VueUeditorWrap,
        fileUploader,
        EditorTemplates,
        selectNodeModal
    },
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            current: 0,
            contentId: 0,
            contentType: 'ContentImage',
            content: {},
            contentRules: {
                title: { required: true, message: '请输入名称', trigger: 'blur' },
                nodeName: { required: true, message: '请选择栏目', trigger: 'blur' },
                contentType: [{ required: true, type: 'number', message: '请选择类型', trigger: 'change' }]
            },
            editorConfig: {
                UEDITOR_HOME_URL: '/UEditor/'
            },
            ueditor: null,
            currentStyle0: {
                display: 'block'
            },
            currentStyle1: {
                display: 'none'
            },
            showAddNodeModal: false,
            businessType: 'content.remarks',
            giDescribe: {
                remarks: ''
            },
            styleTypes: [
                {
                    id: 0,
                    value: '单大图'
                },
                {
                    id: 1,
                    value: '单小图'
                },
                {
                    id: 2,
                    value: '多图'
                }
            ],
            contentTypes: [
                {
                    id: 0,
                    value: '图文'
                },
                {
                    id: 1,
                    value: '外部链接'
                },
                {
                    id: 2,
                    value: '单导航图'
                }
            ]
        };
    },
    methods: {
        showCurrent(current) {
            if (current == 0) {
                this.currentStyle0.display = 'block';
                this.currentStyle1.display = 'none';
            }
            if (current == 1) {
                this.currentStyle0.display = 'none';
                this.currentStyle1.display = 'block';
            }
        },
        editorReady(editor) {
            this.ueditor = editor;
            this.giDescribe = {
                remarks: ''
            };
            // if (this.contentId > 0) {
            //     this.getGraphicInformation(this.businessType);
            // } else {
            //     this.giDescribe = {
            //         remarks: ''
            //     }
            // }
        },
        getContent() {
            this.loading = true;
            this.content = {};
            abp.ajax.get('/api/services/app/Content/GetContentById?id=' + this.contentId)
                .then((resp) => {
                    console.log(resp.data.result);
                    this.content = resp.data.result;
                }).finally(() => {
                this.loading = false;
            });
        },
        showContent() {
            this.getContent();
            this.current = 0;
            this.showCurrent(this.current);
        },
        saveContent() {
            if (this.content.contentType == 1) {
                if (!this.content.source) {
                    this.$Message.error('请填写来源');
                    return;
                }
            }
            this.$refs.contentForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Content/SaveContent', this.content).then(
                        (resp) => {
                            this.contentId = resp.data.result;
                            this.content.id = resp.data.result;
                            if (this.content.contentType === 0) {
                                this.current = 1;
                                this.showCurrent(this.current);
                                this.getGraphicInformation(this.businessType);
                            } else {
                                this.$router.push({
                                    name: 'contentList'
                                });
                            }

                        }, () => {
                        }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        getGraphicInformation(businessType) {
            this.loading = true;
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' +
                this.contentId + '&businessType=' + businessType)
                .then((
                    resp) => {
                    if (resp.data.result != null) {
                        this.giDescribe = resp.data.result;
                    } else {
                        this.giDescribe = {
                            id: 0,
                            content: '',
                            businessType: businessType
                        };
                    }

                }).finally(() => {
                this.loading = false;
            });
        },
        saveDescribe() {
            this.saving = true;
            this.giDescribe.businessId = this.contentId;
            abp.ajax.post('/api/services/app/GraphicInformation/SaveGraphicInformationByBussin', this.giDescribe).then(
                (resp) => {
                    this.$router.push({
                        name: 'contentList'
                    });
                    this.saving = false;
                }, () => {
                });
        },
        showAddNode() {
            this.showAddNodeModal = true;
        },
        addNode(node) {
            this.content.nodeName = node.nodeName;
            this.content.nodeId = node.id;
            this.showAddNodeModal = false;
        }
    },
    created() {
        this.contentId = parseInt(this.$route.params.id || 0);
        if (this.contentId != 0) {
            this.getContent();
        }
    },
    computed: {},
    mounted() {
        // const vm = this;
        // $('.template-list li').on('click', function() {
        //     if ($(this).find('div.tpl-code').length > 0) {
        //         vm.ueditor.setContent('');
        //         vm.ueditor.execCommand('insertHtml', $(this).find('div.tpl-code').html());
        //     } else {
        //         vm.ueditor.execCommand('insertHtml', $(this).html());
        //     }
        // });
    },
    watch: {
        '$route'(to, from) {
            // data数据操作
            if (to.name === 'contentEdit') {
                this.contentId = parseInt(this.$route.params.id || 0);
                this.content = {};
                this.current = 0;
                this.showCurrent(this.current);
                if (this.contentId != 0) {
                    this.getContent();
                }
            }
        }
        // $route: {
        //     handler: function (val, oldVal) {
        //         this.current = 0;
        //         this.contentId = parseInt(this.$route.params.id || 0);
        //         this.currentStyle0.display = 'block';
        //         this.currentStyle1.display = 'none';
        //         if (this.contentId != 0) {
        //             this.getContent();
        //         }
        //     },
        //     deep: true
        // }
    }

};
